/* =====================================================================
   ESCANEAR VARIOS: LA BANDEJA · DIRECTRIZ-ALTA-POR-ESCANEO F7
   =====================================================================
   Cada lectura cae en la bandeja. Funciones puras: la pantalla
   (`EscanearVarios.jsx`) solo pinta y llama.

   LECTURAS REPETIDAS. La cámara vuelve a leer el mismo código unas diez
   veces por segundo mientras lo tiene delante, y un lector de mano puede
   disparar dos veces. Regla: el mismo código visto otra vez a menos de
   2 s de la ÚLTIMA vez que se vio cuenta como una sola lectura (y renueva
   la marca); visto otra vez después de eso, suma uno a la cantidad. Así,
   sostener la cámara sobre un código no lo cuenta veinte veces, y pasar
   el mismo producto dos veces sí lo cuenta dos.
   ===================================================================== */
export const VENTANA_MS = 2000;

export const ESTADOS = {
  consultando: 'Buscando…',
  listo: 'Listo',
  revisar: 'Por revisar',
  no_encontrado: 'No encontrado',
  mal_leido: 'Volver a escanear',
  error: 'Sin conexión',
  hecho: 'Guardado',
};

/**
 * Una lectura más. Devuelve `{ bandeja, que }` con `que` en
 * 'nuevo' | 'suma' | 'repetida'. Nunca muta la bandeja recibida.
 */
export function leer(bandeja, codigo, ahora) {
  const c = String(codigo || '').trim();
  if (!c) return { bandeja, que: 'repetida' };
  const i = bandeja.findIndex((x) => x.codigo === c);
  if (i === -1) {
    return { bandeja: [...bandeja, { codigo: c, cantidad: 1, visto: ahora, estado: 'consultando', respuesta: null }],
      que: 'nuevo' };
  }
  const item = bandeja[i];
  const suma = ahora - item.visto >= VENTANA_MS && item.estado !== 'hecho';
  const nuevo = { ...item, visto: ahora, cantidad: item.cantidad + (suma ? 1 : 0) };
  return { bandeja: bandeja.map((x, j) => (j === i ? nuevo : x)), que: suma ? 'suma' : 'repetida' };
}

/** En qué estado queda un código según lo que contestó el servidor. */
export function clasificar(respuesta) {
  const l = respuesta?.lectura;
  if (!l) return 'error';
  if (!l.digito_valido || l.tipo === 'QR_TEGO') return 'mal_leido';
  if (respuesta.ya_es_de) return 'listo';
  if (!respuesta.ficha?.campos?.nombre) return 'no_encontrado';
  return 'revisar';
}

export function conRespuesta(bandeja, codigo, respuesta) {
  return bandeja.map((x) => (x.codigo === codigo
    ? { ...x, respuesta, estado: respuesta ? clasificar(respuesta) : 'error' } : x));
}

export function marcar(bandeja, codigo, estado) {
  return bandeja.map((x) => (x.codigo === codigo ? { ...x, estado } : x));
}

/** «3 listos · 1 por revisar · 1 no encontrado» */
export function resumen(bandeja) {
  const n = (e) => bandeja.filter((x) => x.estado === e).length;
  const partes = [];
  const listos = n('listo');
  const revisar = n('revisar');
  const noEnc = n('no_encontrado');
  const mal = n('mal_leido');
  const hechos = n('hecho');
  if (listos) partes.push(`${listos} ${listos === 1 ? 'listo' : 'listos'}`);
  if (revisar) partes.push(`${revisar} por revisar`);
  if (noEnc) partes.push(`${noEnc} no ${noEnc === 1 ? 'encontrado' : 'encontrados'}`);
  if (mal) partes.push(`${mal} por volver a escanear`);
  if (hechos) partes.push(`${hechos} ${hechos === 1 ? 'guardado' : 'guardados'}`);
  return partes.join(' · ');
}

/**
 * Los que se pueden confirmar EN BLOQUE: los que ya son productos de la
 * empresa (sumar existencia). Lo nuevo se abre uno por uno en la ficha.
 */
export function confirmablesEnBloque(bandeja) {
  return bandeja.filter((x) => x.estado === 'listo');
}

export function seAbreUnoPorUno(item) {
  return item.estado === 'revisar' || item.estado === 'no_encontrado';
}
